import React from "react";
import { motion } from "framer-motion";
import { Bitcoin, CreditCard, Send, Landmark, Wallet, Globe2, Banknote, ShieldCheck } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const ICON_MAP = {
  Skrill: CreditCard,
  Neteller: Wallet,
  PayPal: Landmark,
  "Crypto (BTC / USDT / ETH)": Bitcoin,
  "Kripto (BTC / USDT / ETH)": Bitcoin,
  "Western Union": Globe2,
  MoneyGram: Send,
  "Ria Money Transfer": Banknote,
  Ukash: ShieldCheck,
};

const Payments = () => {
  const { t } = useLang();

  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="payments"
      data-testid="payments-section"
      className="py-20 md:py-28 border-t border-white/10 bg-[var(--hk-surface)]"
    >
      <div className="container-hk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="text-[10px] md:text-xs tracking-[0.35em] text-[var(--hk-red)] font-bold mb-3">
              // 006 · {t.payments.overline}
            </div>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-tight">
              {t.payments.title}
            </h2>
          </div>
          <p className="text-sm text-white/60 max-w-md">{t.payments.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {t.payments.methods.map((m, i) => {
            const Icon = ICON_MAP[m] || CreditCard;
            return (
              <motion.div
                key={m}
                data-testid={`payment-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className="bg-black p-6 md:p-8 flex flex-col items-center justify-center gap-4 group hover:bg-white/[0.03] transition-colors min-h-[140px]"
              >
                <Icon
                  size={32}
                  className="text-white/70 group-hover:text-[var(--hk-red)] transition-colors"
                  strokeWidth={1.5}
                />
                <div className="text-xs md:text-sm font-semibold tracking-[0.1em] text-center text-white/90">
                  {m}
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-6 border border-white/10 bg-black">
          <div className="flex items-center gap-3">
            <ShieldCheck size={20} className="text-[var(--hk-red)]" />
            <p className="text-xs md:text-sm text-white/70">{t.payments.note}</p>
          </div>
          <button
            data-testid="payments-contact-cta"
            onClick={scrollToContact}
            className="btn-red px-5 py-3 text-[11px] font-bold tracking-[0.28em] whitespace-nowrap"
          >
            {t.nav.contact} →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Payments;
